define(
    'providers/dataprovider.lists',[
        "services/config"
    ],
    function(config) {

        function getLibraryList(listId, libraryId, filter) {
            filter = !filter ? 'my' : filter;
            var data = { libraryId: libraryId, listId: listId, filter: filter };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-lists-librarylist",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getImportList(data) {
            return $.Deferred(function (deferred) {
                $.ajax({
                    url: getUrl("lists/import/basic/" + data.listId),
                    type: "PUT",
                    data: data.file,
                    mimeType: "multipart/form-data",
                    contentType: false,
                    cache: false,
                    processData: false,
                    beforeSend: function (req) {
                        req.setRequestHeader('InstanceCode', config.instanceCode);
                    },

                    success: function (result, statusCode, jqXHR) {
                        deferred.resolve(result, statusCode);
                    },
                    error: function (jqXHR, statusCode, errorThrown) {
                        deferred.reject(errorThrown, statusCode);
                    }
                });
            }).promise();
        }

        function followListValue(listValueId) {
            var data = { listValueId: listValueId };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-lists-followlistvalue",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function unfollowListValue(listValueId) {
            var data = { listValueId: listValueId };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-lists-unfollowlistvalue",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getLists() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-lists-lists",
                    data: {},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getListResults(listId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-lists-listresults",
                    data: { listId: listId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getListValues(listId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-lists-listvalues",
                    data: { listId: listId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function addListValue(listId, fieldMap, relatedLists) {
            var data = { listId: listId, fieldMap: fieldMap, relatedLists: relatedLists };
            
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "pos-lists-listvalues",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function updateListValue(listId, fieldMap, relatedLists, listValueId) {
            var data = { listId: listId, listValueId: listValueId, fieldMap: fieldMap, relatedLists: relatedLists };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-lists-listvalues",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function deleteListValue(listId, listValueId) {
            var data = { listId: listId, listValueId: listValueId };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "del-lists-listvalues",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getList(id) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-lists-list",
                    data: { listId: id },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getDisplay(id) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-lists-display",
                    data: { listId: id },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function addList(name, description) {
            var data = { name: name, description: description };
            
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "pos-lists-list",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function updateSettings(id, name, description, codeTitle, descriptionTitle, manytomany) {
            var data = {
                listId: id, name: name, description: description,
                codeTitle: codeTitle, descriptionTitle: descriptionTitle,
                relatedListManyMany: manytomany
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-lists-settings",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function updateDisplay(id, taken) {
            var data = {
                listId: id, columnsToDisplay: taken
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-lists-display",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function deleteList(id) {
            var data = { id: id };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "del-lists-list",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        init();

        return {
            getLibraryList: getLibraryList,
            getImportList: getImportList,
            followListValue: followListValue,
            unfollowListValue: unfollowListValue,
            getLists: getLists,
            getListResults: getListResults, // grid related (includes schema)
            getListValues: getListValues, // lookup values (id/label),
            addListValue: addListValue,
            updateListValue: updateListValue,
            deleteListValue: deleteListValue,
            getList: getList,
            getDisplay: getDisplay,
            addList: addList,
            updateSettings: updateSettings,
            updateDisplay: updateDisplay,
            deleteList: deleteList

    };

        //#region Internal Methods

        function init() {

            //#region Library Related List Value Operations

            amplify.request.define("get-lists-librarylist", "ajax", {
                url: getUrl("lists/{listId}/libraries/{libraryId}/results/{filter}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-lists-exportlist", "ajax", {
                url: getUrl("lists/export/basic/{listId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("put-lists-followlistvalue", "ajax", {
                url: getUrl("lists/listvalues/{listValueId}/follow"),
                dataType: "json",
                type: "POST"
            });

            amplify.request.define("put-lists-unfollowlistvalue", "ajax", {
                url: getUrl("lists/listvalues/{listValueId}/unfollow"),
                dataType: "json",
                type: "DELETE"
            });

            //#endregion

            //#region List Maintenance Operations
            
            amplify.request.define("get-lists-lists", "ajax", {
                url: getUrl("lists"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-lists-listresults", "ajax", {
                url: getUrl("lists/{listId}/results"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-lists-listvalues", "ajax", {
                url: getUrl("lists/{listId}/listvalues"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("pos-lists-listvalues", "ajax", {
                url: getUrl("lists/{listId}/listvalues"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data);
                },
            });

            amplify.request.define("put-lists-listvalues", "ajax", {
                url: getUrl("lists/{listId}/listvalues/{listValueId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                },
            });

            amplify.request.define("del-lists-listvalues", "ajax", {
                url: getUrl("lists/{listId}/listvalues/{listValueId}"),
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("get-lists-list", "ajax", {
                url: getUrl("lists/settings/{listId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-lists-display", "ajax", {
                url: getUrl("lists/display/{listId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("pos-lists-list", "ajax", {
                url: getUrl("lists"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data);
                },
            });

            amplify.request.define("put-lists-settings", "ajax", {
                url: getUrl("lists/settings/{listId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                },
            });

            amplify.request.define("put-lists-display", "ajax", {
                url: getUrl("lists/display/{listId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                },
            });

            amplify.request.define("del-lists-list", "ajax", {
                url: getUrl("lists/{id}"),
                dataType: "json",
                type: "DELETE"
            });
            //#endregion
        }

        function getUrl(action) {            
            return config.webApiUrl + action;
        }

        //#endregion
    }
);
